var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Main',[(_vm.show)?_c('QuotationEditForm',{attrs:{"form":_vm.currentQuotationToEdit},on:{"submit":_vm.submit,"return":_vm.previousPage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }